import { useRef, MouseEvent, useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../context-store";
import AppConfig from "../../config";
import RegisterParams from "../../models/common/PageParms";
import IdNameModel from "../../models/common/IdNameModel";
import RegisterService from "../../services/authentication-service";
import RegisterCompanyModel from "../../models/authentication/RegisterCompany";
import { OBJECT_NAME_RULE, EMAIL_RULE, PASSWORD_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../utils/validation-utils";
import { useForm, Controller } from "react-hook-form";
import masterDataService from '../../services/master-data-service';
import EncryptUtil from '../../utils/encode-utils';
import { RoleEnum } from "../../models/enums/RoleEnum";
import ReCAPTCHA from "react-google-recaptcha";
import CandidateLogo from "../../assets/img/logos/candidate.png";
import InterviewerLogo from "../../assets/img/logos/interviewer.png";
import toasterUtils from "../../utils/toaster-utils";
import modalUtils from "../../utils/modal-utils";
import { TextField, Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, Autocomplete } from "@mui/material";
import SignInImg from "../../assets/img/content/signin.png";

const RegisterCompany = () => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
        reset,
        control
    } = useForm<RegisterCompanyModel>({
        mode: "onChange",
    });
    const [country, setCountry] = useState<IdNameModel[]>([]);
    const captchaRef: any = useRef(null);
    const siteKey = AppConfig.envVariables.recapchaSiteKey;

    useEffect(() => {
        getCountry();
    }, [])

    const requestParams: RegisterParams = useParams();
    const history = useHistory();
    const authenticated = useAppSelector(
        (state: any) => state.authState.authenticated
    );

    if (authenticated) {
        return <Redirect to="/"></Redirect>;
    };

    const signIn = (event: MouseEvent) => {
        event.preventDefault();
        history.push("/login");
    };

    const fnRegister = (event: MouseEvent, registerType: string) => {
        event.preventDefault();
        history.push("/register/" + registerType);
    }

    const onSubmit = (registerFormData: RegisterCompanyModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        const token = captchaRef.current.getValue();
        captchaRef.current.reset();
        if (token === null || token === '') {
            toasterUtils.showWarning("Please accept captcha.");
            return;
        }
        registerFormData.password = EncryptUtil.getEncoded(registerFormData.password);
        registerFormData.confirmPassword = EncryptUtil.getEncoded(registerFormData.confirmPassword);
        if (registerFormData.password != registerFormData.confirmPassword) {
            alert("passwords doesn't match");
        } else {
            registerFormData.mobileNumber = Number(registerFormData.mobileNumber);
            registerFormData.countryId = Number(registerFormData.countryId);
            registerFormData.roleId = Number(RoleEnum.ClientAdmin);
            registerFormData.emailId = registerFormData.userName;
            modalUtils.showLoader();
            RegisterService.registerCompany(registerFormData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    history.push("/login");
                }, 1000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr registering user " + error);
            });
        }
    };

    const getCountry = () => {
        modalUtils.showLoader();
        masterDataService.loadCountries().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCountry(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const clearForm = () => {
        reset({
            name: "",
            userName: "",
            password: "",
            confirmPassword: "",
            mobileNumber: 0,
            countryId: 0,
            cityId: 0,
        });
    };

    return (
        <section className="bg-light md">
            <div className="container-body">
                <div className="row">
                    <div className="col-lg-6 mb-4 mb-lg-0 login-hero-image"><img src={SignInImg} alt="Sign In" /></div>
                    <div className="col-lg-6">
                        <div className="container-body">
                            <div className="contact-form-box">
                                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="quform-elements">
                                        <div className="row">
                                            <div className="col-md-12">
                                                 <h2 className="section-title">Sign up as {requestParams.type}</h2>
                                            </div>
                                           
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.name}>
                                                    <TextField label="Company Name" size="small" {...register("name", OBJECT_NAME_RULE)} error={!!errors.name}
                                                        helperText={errors.name?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.userName}>
                                                    <TextField type="Email" label="Email/User Name" size="small" {...register("userName", EMAIL_RULE)} error={!!errors.userName}
                                                        helperText={errors.userName?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.password}>
                                                    <TextField type="password" label="Password" size="small" {...register("password", PASSWORD_RULE)} error={!!errors.password}
                                                        helperText={errors.password?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.confirmPassword}>
                                                    <TextField type="password" label="Confirm Password" size="small" {...register("confirmPassword", PASSWORD_RULE)} error={!!errors.confirmPassword}
                                                        helperText={errors.confirmPassword?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                                                    <TextField type="text" label="Mobile Number" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                                                        helperText={errors.mobileNumber?.message} autoComplete="off" required sx={{ backgroundColor: "white" }} />
                                                </FormControl>
                                            </div>
                                            <div className="col-md-6">
                                                <Controller name="countryId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                                    render={({ field }) => (
                                                        <Autocomplete {...field} value={country.find(x => x.id === field.value) || null}
                                                            onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={country} getOptionLabel={(option) => option.name || ""}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Country" size="small" required margin="normal" fullWidth error={!!errors.countryId} helperText={errors.countryId?.message} sx={{ backgroundColor: "white" }} />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <div className="quform-element form-group">
                                                    <div className="quform-input">
                                                        <ReCAPTCHA sitekey={siteKey} ref={captchaRef} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-7 register-block-btns">
                                                <Button variant="contained" color="primary" type="submit" size="large" sx={{ mt: 3 }}>
                                                    Register
                                                </Button>
                                                <Button variant="contained" color="inherit" className="m-l-xxs" size="large" type="button"
                                                    onClick={clearForm} sx={{ mt: 3, color: "#898989", backgroundColor: "#d1d1d1" }}>
                                                    Cancel
                                                </Button>
                                            </div>
                                            <div className="col-md-5 register-block-already-registered">
                                                <span className="sign-in-question" ><a onClick={(e) => { signIn(e); }}>Already Registered ? Sign in</a></span>
                                            </div>
                                            <div className="signup-different-user">
                                                <p className="login-title">Sign up as</p>
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6 signup-different-options">
                                                        <img className="register-block-signup-interviewer-logo" src={CandidateLogo} alt=""></img>
                                                        <h3><a onClick={(e) => { fnRegister(e, "Candidate"); }}>Candidate</a></h3>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 signup-different-options">
                                                        <img src={InterviewerLogo} alt="" className="register-block-signup-company-logo"></img>
                                                        <h3><a onClick={(e) => { fnRegister(e, "Interviewer"); }}>Interviewer</a></h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default RegisterCompany;